export const stringLength = {
  TITLE: 90
}
